import session from "../../../../services/session";
import swal from "sweetalert2";
import AdminApi from '../../../../services/api'

const AdminApiService = new AdminApi();

export default {
    data() {
        return {
            model: {
                expireDate: null,
                paidDate: null,
                paidMoney: 0,
                trainingNumber: 0,
                userId: 0,
                types: []
            },
            types: [],

        }
    },
    methods: {
        addPayment: addPayment,
        getTrainingTypes: getTrainingTypes,
        onChangeCheckBox: onChangeCheckBox
    },
    beforeMount() {
        if (session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN') {
            this.$router.push('/home');
            return;
        }
        this.model.userId = this.$route.query.id;
        this.getTrainingTypes()
    }
}

function addPayment() {
    let _self = this;
    if(_self.model.types.length === 0){
        swal('Greška','Izaberite tip treninga', 'error')
        return;
    }
    _self.model.paidDate =this.model.paidDate + 'T00:00:00.000Z';
    _self.model.expireDate =this.model.expireDate + 'T00:00:00.000Z';
    AdminApiService.addPayment(_self.model)
        .then((response) => {
            swal('Uspešno', 'Uspešno dodata uplata.', 'success')
            this.$router.push('/payment-user?id='+_self.model.userId);
        })
        .catch(error => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function getTrainingTypes() {
    let _self = this;
    AdminApiService.getTrainingTypes()
        .then((response) => {
            _self.types = response.data
        })
        .catch(error => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function onChangeCheckBox(key) {
    let isChecked = document.getElementById(key).checked
    if(isChecked){
        if(this.model.types.indexOf(key) < 0){
            this.model.types.push(key);
        }
    }else{
        const index = this.model.types.indexOf(key);
        if (index > -1) {
            this.model.types.splice(index, 1);
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/Users/Payment/Add/AddPayment.js